module.exports = __webpack_public_path__ + "static/img/我的医生@3x.f2c877f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom/我的医生@3x.png
// module id = 1251
// module chunks = 382